import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import '../../styles/core.scss';
import Button from '../button/index';
import MultilineText from '../../components/multiline-text/index';
import css from './index.scss';
import messages from './messages';

const AssignedClassesGroups = ({ assignedTo = [], showAssignButton = true, handleOnAssignClass, dependentValues, intl }) => {
    let assignElement = [];
    if (assignedTo.length > 0) {
        assignElement = <MultilineText dataItems={assignedTo} />;
    } else if (showAssignButton) {
        assignElement = (<Button
            containerClassName={css.assign}
            disabled={false}
            handleOnClick={() => handleOnAssignClass(dependentValues.userProfileId)}
            label={intl.formatMessage(messages.assignClass)} />);
    }

    return (
        <div className={css.component}>
            {assignElement}
        </div>
    );
};

AssignedClassesGroups.propTypes = {
    assignedTo: PropTypes.array,
    showAssignButton: PropTypes.bool,
    dependentValues: PropTypes.object,
    handleOnAssignClass: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(AssignedClassesGroups));



// WEBPACK FOOTER //
// ./app/components/assigned-classes-groups/index.js